const dirtyNodesMapSelector = ({ WorkflowCache: { dirtyNodesMap } }) => dirtyNodesMap;

export default dirtyNodesMapSelector;
